<template>
  <div>
    <v-card-text class="py-0">
      <div style='display: flex;'>
        <numberForm
          label="最小数"
          v-model="regulationItem.rules.minimumWords"
        ></numberForm>
        <numberForm
          label="最大数"
          v-model="regulationItem.rules.maximumWords"
        ></numberForm>
      </div>
    </v-card-text>
  </div>
</template>

<script>
import numberForm from './forms/numberForm'

export default {
  name: 'IntroductionRangeLimit',
  components: {
    numberForm
  },
  props: {
    regulationItem: {
      type: Object,
      required: true
    }
  }
}
</script>
